import * as React from 'react';
import { CommentInput } from './comment-input/comment-input';
import { RowContainerComponentProps, ValidationSummary } from 'ui';
import styles from './comment-tile-view.scss';

/**
 * Creates Comment component. Consists of comments list and an input field.
 *
 */
interface CommentTileViewTranslations {
  /**
   * The label text for the add button
   */
  textAddItem?: string;
  /**
   * fallback text if no comments have been added
   */
  textNoData?: string;
  /**
   * The placeholder text for input area
   */
  placeholder?: string;
  /**
   * The maximum number of characters allowed to input. Default is 4000.
   */
  maxLength?: number;
  hideTextNoData?: boolean;
}

export type CommentTileViewProps = RowContainerComponentProps & CommentTileViewTranslations;

export class CommentTileView extends React.PureComponent<CommentTileViewProps, any> {

  public render() {
    const {componentId,
           readOnly,
           children,
           enabledChildEntityOperations = { add: false },
           textAddItem,
           textNoData,
           placeholder,
           validation,
           label,
           maxLength,
           className,
           hideTextNoData = false} = this.props;

    const commentCount = React.Children.count(children);
    const rows = React.Children.map(children, child => {
      return <li>{child}</li>;
    });

    return <div id={componentId} className={`${styles.commentView} ${className}`}>
        {label && label.text && label.visible && <h3 className={styles.commentHeading}>{label.text}</h3>}
        <ValidationSummary validationError={validation}/>
        {commentCount > 0 && <ul>{rows}</ul>}
        {commentCount === 0 && textNoData && !hideTextNoData && <p className="no-content">{textNoData}</p>}
        {!readOnly && enabledChildEntityOperations?.add  &&
          <CommentInput textAddItem={textAddItem} placeholder={placeholder} maxLength={maxLength}{...this.props}/>
        }
      </div>;
  }
}
